import React from 'react';
import { Card, CardContent, CardHeader } from './ui/card';
import { Badge } from './ui/badge';
import { Calendar, DollarSign, Package, Quote } from 'lucide-react';
import { mockData } from '../mock';

const CaseStudySection = () => {
  return (
    <section id="case-study" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-6">
            {mockData.caseStudy.title}
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Case study details */}
          <div className="space-y-8">
            {/* Background with integrated project info */}
            <Card className="border-0 shadow-lg">
              <CardHeader>
                <h3 className="text-xl font-bold text-gray-900">ご依頼背景</h3>
              </CardHeader>
              <CardContent>
                <ul className="mb-4 space-y-1">
                  <li className="flex items-start gap-2">
                    <span className="text-gray-600 mt-0.5">・</span>
                    <span><strong>ご予算：</strong> <span className="text-blue-600 font-black text-lg">{mockData.caseStudy.budget}</span></span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gray-600 mt-0.5">・</span>
                    <span><strong>制作点数：</strong> <span className="text-blue-600 font-black text-lg">{mockData.caseStudy.points}</span></span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-gray-600 mt-0.5">・</span>
                    <span><strong>制作期間：</strong> <span className="text-blue-600 font-black text-lg">{mockData.caseStudy.period}</span></span>
                  </li>
                </ul>
                
                <hr className="border-0 border-t border-gray-200 my-4" />
                
                <p className="text-gray-600 leading-relaxed">
                  {mockData.caseStudy.background}
                </p>
              </CardContent>
            </Card>

            {/* Results */}
            <Card className="border-0 shadow-lg">
              <CardHeader>
                <h3 className="text-xl font-bold text-gray-900">成果</h3>
              </CardHeader>
              <CardContent>
                <ul className="list-disc ml-5 space-y-3">
                  {mockData.caseStudy.results.map((result, index) => {
                    // 1つ目の項目の特定部分を強調
                    if (index === 0) {
                      const parts = result.split('発売前にブランド宣伝が可能に。');
                      return (
                        <li key={index} className="text-gray-600 leading-relaxed">
                          {parts[0]}<span className="font-bold text-lg">発売前にブランド宣伝が可能に。</span>
                        </li>
                      );
                    }
                    // 2つ目の項目のテキストを変更して強調
                    if (index === 1) {
                      return (
                        <li key={index} className="text-gray-600 leading-relaxed">
                          3Dデータも納品したため、別の商品画像や3Dモデル表示などの、<span className="font-bold text-lg">再利用が可能</span>
                        </li>
                      );
                    }
                    return (
                      <li key={index} className="text-gray-600 leading-relaxed">
                        {result}
                      </li>
                    );
                  })}
                </ul>
              </CardContent>
            </Card>

            {/* Testimonial */}
            <Card className="bg-gradient-to-br from-blue-50 to-green-50 border-0 shadow-lg">
              <CardContent className="p-8">
                {/* <Quote className="w-12 h-12 text-blue-300 mb-4" /> */}
                <p className="text-lg text-gray-700 leading-relaxed italic mb-6">
                  "{mockData.caseStudy.testimonial}"
                </p>
                <div className="text-right">
                  <p className="font-semibold text-gray-900">
                    Extra Basic様
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Images */}
          <div className="space-y-6">
            <h3 className="text-xl font-bold text-gray-900 text-center">
              制作事例画像
            </h3>
            
            <div className="space-y-4">
              {mockData.caseStudy.images.map((image, index) => (
                <div key={index} className="group cursor-pointer">
                  <div className="relative overflow-hidden rounded-xl shadow-lg group-hover:shadow-2xl transition-shadow">
                    <img 
                      src={image}
                      alt={`Chew Crew 制作事例 ${index + 1}`}
                      className="w-full h-auto max-h-[600px] object-contain group-hover:scale-105 transition-transform duration-300 bg-white"
                    />
                    <div className="absolute inset-0 bg-black/10 opacity-0 transition-opacity" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudySection;